import React, { ComponentProps } from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export const Phone = ({ width = 24, height = 24, ...restProps }: ComponentProps<typeof SvgIcon>) => (
  <SvgIcon {...restProps} viewBox={`0 0 ${width} ${height}`}>
    <path
      d="M17.023 12.488C16.393 12.473 15.6 12.436 15.099 12.348C14.557 12.252 13.905 12.066 13.446 11.923C13.086 11.811 12.694 11.91 12.427 12.176L10.21 14.38C8.678 13.573 7.451 12.633 6.412 11.588C5.367 10.549 4.427 9.322 3.62 7.79L5.824 5.572C6.09 5.304 6.189 4.913 6.077 4.553C5.935 4.095 5.748 3.442 5.652 2.9C5.564 2.399 5.527 1.607 5.512 0.976C5.499 0.431999 5.055 -2.20961e-07 4.51 -1.97138e-07L0.999999 -4.37114e-08C0.561999 -2.45658e-08 -7.72468e-07 0.327999 -7.43094e-07 1C-5.44688e-07 5.539 1.84 9.874 4.966 13.034C8.126 16.16 12.461 18 17 18C17.672 18 18 17.438 18 17L18 13.49C18 12.945 17.568 12.501 17.023 12.488Z"
      fill="white"
    />
  </SvgIcon>
)
